import createOrUpdateHiddenField from './createOrUpdateHiddenField';

const injectShiftSessionId = (form) => {
	const shiftSessionId = sessionStorage.getItem('SaveShiftSession');

	if (shiftSessionId) {
		createOrUpdateHiddenField(
			form,
			'_custom=SHIFT_SESSION_ID=-1=shiftSessionId',
			shiftSessionId
		);
	}
};

export default injectShiftSessionId;
